/**
 * Comparison Mobile Switcher
 * Transforms divs with class 'comparison-mobile-switcher' or 'comparison-dedicated-switcher'
 * into interactive tab switchers for comparison article pages
 * 
 * - comparison-mobile-switcher: Second tab shows "IM8 Advantage" (or image alt text)
 * - comparison-dedicated-switcher: Second tab shows "im8's dedicated complex & dose" with line break
 */

document.addEventListener('DOMContentLoaded', function() {
  // Find all comparison mobile switcher divs (both regular and dedicated)
  const switchers = document.querySelectorAll('.comparison-article-container .comparison-mobile-switcher, .comparison-article-container .comparison-dedicated-switcher');
  
  switchers.forEach(function(switcher) {
    // Check if this is a dedicated switcher
    const isDedicatedSwitcher = switcher.classList.contains('comparison-dedicated-switcher');
    initMobileSwitcher(switcher, isDedicatedSwitcher);
  });
  
  function initMobileSwitcher(switcher, isDedicatedSwitcher) {
    // Get all images inside the switcher
    const images = Array.from(switcher.querySelectorAll('img'));
    
    // We need exactly 2 images for the comparison
    if (images.length !== 2) {
      console.warn('Comparison mobile switcher requires exactly 2 images');
      return;
    }
    
    // Store original content
    const image1 = images[0];
    const image2 = images[1];
    
    // Get the alt text or default labels
    const label1 = image1.alt || 'Comparison';
    const label2 = isDedicatedSwitcher 
      ? "IM8's Dedicated <br> Complex & Dose" 
      : (image2.alt || 'IM8 Advantage');
    
    // Clear the switcher content
    switcher.innerHTML = '';
    
    // Create tabs container
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'comparison-mobile-switcher-tabs';
    
    // Create the sliding white pill indicator
    const indicator = document.createElement('div');
    indicator.className = 'comparison-mobile-switcher-indicator';
    
    // Create tab 1 (active by default)
    const tab1 = document.createElement('button');
    tab1.className = 'comparison-mobile-switcher-tab is-active';
    tab1.textContent = label1;
    tab1.setAttribute('type', 'button');
    tab1.setAttribute('aria-label', `Show ${label1}`);
    
    // Create tab 2
    const tab2 = document.createElement('button');
    tab2.className = 'comparison-mobile-switcher-tab';
    // Use innerHTML for dedicated switcher to support <br> tag
    if (isDedicatedSwitcher) {
      tab2.innerHTML = label2;
    } else {
      tab2.textContent = label2;
    }
    tab2.setAttribute('type', 'button');
    tab2.setAttribute('aria-label', `Show ${label2.replace(/<br>/g, ' ')}`);
    
    // Add indicator first (so it's behind the tabs in z-index)
    tabsContainer.appendChild(indicator);
    tabsContainer.appendChild(tab1);
    tabsContainer.appendChild(tab2);
    switcher.appendChild(tabsContainer);
    
    // Create content container
    const contentContainer = document.createElement('div');
    contentContainer.className = 'comparison-mobile-switcher-content';
    
    // Create track (this will slide)
    const track = document.createElement('div');
    track.className = 'comparison-mobile-switcher-track';
    
    // Create slides
    const slide1 = document.createElement('div');
    slide1.className = 'comparison-mobile-switcher-slide is-active';
    slide1.appendChild(image1);
    
    const slide2 = document.createElement('div');
    slide2.className = 'comparison-mobile-switcher-slide';
    slide2.appendChild(image2);
    
    track.appendChild(slide1);
    track.appendChild(slide2);
    contentContainer.appendChild(track);
    switcher.appendChild(contentContainer);
    
    // State management
    let currentSlide = 0;
    
    // Set initial height based on first image
    function updateHeight() {
      const activeSlide = currentSlide === 0 ? slide1 : slide2;
      const activeImg = activeSlide.querySelector('img');
      if (activeImg.complete) {
        contentContainer.style.height = activeImg.offsetHeight + 'px';
      } else {
        activeImg.addEventListener('load', function() {
          contentContainer.style.height = activeImg.offsetHeight + 'px';
        });
      }
    }
    
    // Initialize height
    updateHeight();
    
    // Switch function with fade transition
    function switchToSlide(index) {
      if (index === currentSlide) return;
      
      currentSlide = index;
      
      // Fade transition between slides
      if (index === 0) {
        slide1.classList.add('is-active');
        slide2.classList.remove('is-active');
        tab1.classList.add('is-active');
        tab2.classList.remove('is-active');
        indicator.classList.remove('slide-right');
      } else {
        slide1.classList.remove('is-active');
        slide2.classList.add('is-active');
        tab1.classList.remove('is-active');
        tab2.classList.add('is-active');
        indicator.classList.add('slide-right');
      }
      
      // Update container height to match active image
      updateHeight();
    }
    
    // Tab click handlers
    tab1.addEventListener('click', function() {
      switchToSlide(0);
    });
    
    tab2.addEventListener('click', function() {
      switchToSlide(1);
    });
    
    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    
    contentContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    contentContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      if (touchEndX < touchStartX - swipeThreshold) {
        // Swipe left - go to next slide
        if (currentSlide === 0) {
          switchToSlide(1);
        }
      } else if (touchEndX > touchStartX + swipeThreshold) {
        // Swipe right - go to previous slide
        if (currentSlide === 1) {
          switchToSlide(0);
        }
      }
    }
    
    // Keyboard navigation
    switcher.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft' && currentSlide === 1) {
        e.preventDefault();
        switchToSlide(0);
      } else if (e.key === 'ArrowRight' && currentSlide === 0) {
        e.preventDefault();
        switchToSlide(1);
      }
    });
  }
});

